<section 
    class="container-wrapper"
    [class.has-border]="hasBorder"
    [class.touched]="formTouched"
    [class.valid]="formValid"
    [class.invalid]="formInvalid"
>
    <form [formGroup]="scheduleForm">
        <div class="display">
            <div class="row">
                <div class="form">
                    <div class="row">
                        <div class="input-wrapper date-select">
                            <app-form-datepicker 
                                [label]="'pages.collections.configuration.form.sections.schedules.startDateLabel' | translate"
                                formControlName="from"
                                [large]="true"
                                [min]="startDateMin"
                                (change)="fromDateChange($event)"
                            >
                                <app-form-error *ngIf="from.touched && from.hasError('required')">
                                    {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidStartDate' | translate }}
                                </app-form-error>
                            </app-form-datepicker>
                        </div>
                        <div class="input-wrapper date-select">
                            <app-form-datepicker 
                                [class.ng-invalid]="scheduleForm.hasError('dateRange')"
                                [label]="'pages.collections.configuration.form.sections.schedules.endDateLabel' | translate" 
                                [large]="true"
                                formControlName="to" 
                                [min]="endDateMin"
                                (change)="toDateChange($event)"
                            >
                                <app-form-error *ngIf="to.touched && to.hasError('required')">
                                    {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidEndDate' | translate }}
                                </app-form-error>
                                <app-form-error *ngIf="scheduleForm.hasError('dateRange')">
                                    {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidDateRange' | translate }}
                                </app-form-error>
                            </app-form-datepicker>
                        </div>
                        <div class="input-wrapper time-input">
                            <app-bciti-time-input
                                [label]="'pages.collections.configuration.form.sections.schedules.startFromLabel' | translate" 
                                formControlName="fromTime"
                            >
                                <app-form-error *ngIf="fromTime.touched && fromTime.hasError('required')">
                                    {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidFromTime' | translate }}
                                </app-form-error>
                            </app-bciti-time-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-wrapper text-select">
                            <app-bciti-text-select 
                                class="default-schedule-repeat-select"
                                formControlName="frequency"
                                [label]="'pages.collections.configuration.form.sections.schedules.selectLabel' | translate"
                                [placeholder]="'pages.collections.configuration.form.sections.schedules.placeholder' | translate"
                                [options]="optionsFrequencies"
                            >
                                <app-form-error *ngIf="frequency.touched && frequency.hasError('required')">
                                    {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidFrequency' | translate }}
                                </app-form-error>
                            </app-bciti-text-select>
                        </div>
                    </div>
                </div>
                <div class="actions">
                    <button *ngIf="closeable" mat-icon-button type="button" (click)="cancelCreateAction()">
                        <span class="icon-close"></span>
                    </button>
                </div>
            </div>
            <div class="day-list-container">
            <span class="section-infos">{{ 'pages.collections.configuration.form.sections.schedules.chipListText' | translate }}</span>
                <app-chip-list
                    [options]="optionsDays"
                    [class]="chipClass"
                    formControlName="days"
                >
                    <app-form-error *ngIf="days.touched && days.hasError('required')">
                        {{ 'pages.collections.configuration.form.sections.schedules.errors.invalidDays' | translate }}
                    </app-form-error>
                </app-chip-list>
            </div>
        </div>
    </form>
    <!-- <app-form-error *ngIf="overlapError">{{'pages.collections.configuration.form.sections.schedules.errors.overlap' | translate}}</app-form-error> -->
</section>